export const APP_STORE_URL = 'https://apps.apple.com/app/id6760713155';
export const MAC_APP_STORE_URL = 'https://apps.apple.com/app/notetime-timeline-dated-notes/id6760713155';
